import i18next from 'i18next';
import I18NextVue from 'i18next-vue';
import en from './locales/en.json';
import es from './locales/es.json';

const STORAGE_KEY = 'hf-inbox-locale';

export function getStoredLocale(): 'en' | 'es' {
  const v = localStorage.getItem(STORAGE_KEY);
  if (v === 'en' || v === 'es') return v;
  const browser = navigator.language?.toLowerCase() ?? 'en';
  return browser.startsWith('es') ? 'es' : 'en';
}

export function setLocale(lng: 'en' | 'es') {
  localStorage.setItem(STORAGE_KEY, lng);
  i18next.changeLanguage(lng);
}

export async function setupI18n() {
  await i18next.init({
    lng: getStoredLocale(),
    fallbackLng: 'en',
    resources: { en: { translation: en }, es: { translation: es } },
    interpolation: { escapeValue: false },
  });
  return { i18next, I18NextVue };
}
